import { log } from '@/log'
import { IncorrectAuthenticationDataError, TooManyRequestedError } from '@spa/components/pages/auth/login/model/error'
import { LoginGateway } from '@spa/components/pages/auth/login/model/interaction/login'
import { AuthenticationData } from '@spa/components/pages/auth/login/model/state'
import { RootState } from '@spa/store/types'
import _ from 'lodash'
import { Store } from 'vuex'

export const vuexStoreGateway = (store: Store<RootState>): LoginGateway => ({
  async login({ email, password }: AuthenticationData): Promise<null> {
    await store.dispatch('user/login', {
      username: email,
      password,
    })

    const error = store.state.user.error.login
    if (error) {
      const status = _.get(error, 'status')

      log.error(error, status)

      // tslint:disable-next-line
      if (status === 429) {
        return Promise.reject(
          new TooManyRequestedError(error.message)
        )
      }
      // tslint:disable-next-line
      if (status === 401) {
        return Promise.reject(
          new IncorrectAuthenticationDataError(error.message)
        )
      }

      return Promise.reject(error)
    }

    /**
     * In an effort to prevent resetting of current loading state
     * abruptly 'initWithoutViewState' is used instead of 'init'
     */
    await store.commit('initWithoutViewState')

    return null
  },
})
